/**
 * Initialize OAuth2 Token Client and returns OAuth2 Client
 * @param {string} clientId
 * @param {function} callback
 * @param {string} scope
 * @returns {object | null}
 */
function initializeGoogle(clientId, callback, callbackError, scope) {
    var _a, _b, _c;
    if (scope === void 0) { scope = 'email profile openid'; }
    var google = window.google;
    if (!(google && (google === null || google === void 0 ? void 0 : google.accounts) && ((_a = google === null || google === void 0 ? void 0 : google.accounts) === null || _a === void 0 ? void 0 : _a.oauth2)))
        return;
    var OAuth2 = (_c = (_b = google === null || google === void 0 ? void 0 : google.accounts) === null || _b === void 0 ? void 0 : _b.oauth2) === null || _c === void 0 ? void 0 : _c.initTokenClient({
        client_id: clientId,
        scope: scope,
        callback: callback,
        error_callback: callbackError
    });
    return OAuth2;
}
/**
 * Authenticates user
 * @param {object} OAuth2Client
 * @returns {void}
 */
function authenticateUser(OAuth2Client) {
    OAuth2Client.requestAccessToken();
}
var GoogleService = {
    initializeGoogle: initializeGoogle,
    authenticateUser: authenticateUser
};
export default GoogleService;
